<template>
  <div>
    <base-contest-problem-card
      v-for="problem in contestDay.problems"
      :key="problem.id"
      :day="contestDay.day"
      :onClick="() => onClick(problem.id)"
      :problem="problem"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BaseContestProblemCard from './BaseContestProblemCard.vue'

export default defineComponent({
  components: {
    BaseContestProblemCard
  },
  props: {
    contestDay: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  }
})
</script>

<style></style>
